import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import { useRouteMatch } from 'react-router-dom'
import { ChargingStart } from './ChargingStart'
import { ChargingInProgress } from './ChargingInProgress'
import { ChargingDone } from './ChargingDone'
import { useSelector, useDispatch } from 'react-redux'
import { Location, LocationInfo, } from '../../shared/types/location'
import { fetchLocationDetail } from '../../redux/actions/locations'
import { ChargingSession, ChargingSessionState } from '../../shared/types/chargingSession'

const useStyles = makeStyles((theme) => ({
    main: {
        height: '100%',
        backgroundColor: 'black',
    },
}))

export default function Charging() {
    const classes = useStyles()

    const chargingRouteMatch = useRouteMatch(`/charging/:locationId`)
    const routeParams: any = chargingRouteMatch?.params
    const locationId: string = routeParams?.locationId

    const dispatch = useDispatch()
    const location = useSelector((state: any) => state.locationDetail.value) as Location
    const locations = useSelector((state: any) => state.locations.value?.items ?? state.locations.value) as LocationInfo[]
    const locationInfo: LocationInfo | undefined = locations?.find((l: LocationInfo) => l.id === locationId)

    const chargingSession: ChargingSession = useSelector((state: any) => state.chargingSession.value)

    if (!location) {
        switch (chargingSession?.state) {
            case ChargingSessionState.InProgress:
            case ChargingSessionState.Parking:
            case ChargingSessionState.Finished:
                break
        }
    }

    useEffect(() => {
        if (!location || location.id !== locationId) {
            dispatch(fetchLocationDetail(locationId));
        }
    }, [dispatch, location, locationId])

    let content: any
    if (location) {
        const locationData = locationInfo ?? location as unknown as LocationInfo
        switch (chargingSession?.state) {
            case ChargingSessionState.InProgress:
            case ChargingSessionState.Parking:
                content = <ChargingInProgress location={locationData} />
                break
            case ChargingSessionState.Finished:
                content = <ChargingDone location={locationData} />
                break
            default:
                content = <ChargingStart location={locationData} />
        }
    }

    return (
        <Grid className={classes.main} container direction="column" wrap="nowrap">
            {content}
        </Grid>
    )
}
